import error_404 from './error_404'

export default error_404;